import { useApp } from '../context/AppContext';

const NAV_STRUCTURE = [
  { section: 'Operations' },
  { id: 'rentals',      label: 'Rentals',          icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 11l3 3L22 4"/><path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11"/></svg> },
  { id: 'incoming',     label: 'Incoming',          icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.81 19.79 19.79 0 01.22 1.18 2 2 0 012.18 0h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 7.09a16 16 0 006 6l.56-.56a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/></svg> },
  { section: 'Fleet' },
  { id: 'map',          label: 'Live Map',          icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="10" r="3"/><path d="M12 2a8 8 0 00-8 8c0 5.4 7.05 11.5 7.35 11.76a1 1 0 001.3 0C12.95 21.5 20 15.4 20 10a8 8 0 00-8-8z"/></svg> },
  { id: 'fleet',        label: 'Fleet & Pricing',   icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="1" y="3" width="15" height="13" rx="2"/><path d="M16 8h4l3 4v3h-7V8z"/><circle cx="5.5" cy="18.5" r="2.5"/><circle cx="18.5" cy="18.5" r="2.5"/></svg> },
  { id: 'maintenance',  label: 'Maintenance',       icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/></svg> },
  { id: 'damages',      label: 'Damages',           icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg> },
  { id: 'history',      label: 'Rental History',    icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M12 8v4l3 3"/><circle cx="12" cy="12" r="9"/><path d="M3.05 11a9 9 0 116 14"/><path d="M3 16v-5h5"/></svg> },
  { section: 'Finance & CRM' },
  { id: 'invoices',     label: 'Pro Formas',        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10,9 9,9 8,9"/></svg> },
  { id: 'refunds',      label: 'Refunds',           icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><polyline points="1,4 1,10 7,10"/><path d="M3.51 15a9 9 0 102.13-9.36L1 10"/></svg> },
  { id: 'revenue',      label: 'Revenue',           icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/></svg> },
  { id: 'customers',    label: 'Customers',         icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/></svg> },
  { section: 'Booking Engine' },
  { id: 'bookingsetup', label: 'Booking Page',      icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><path d="M2 12h20M12 2a15.3 15.3 0 010 20M12 2a15.3 15.3 0 000 20"/></svg> },
  { id: 'agreement',    label: 'Agreements',        icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z"/><polyline points="14,2 14,8 20,8"/></svg> },
  { id: 'emailtemplates', label: 'Email Templates', icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/><polyline points="22,6 12,13 2,6"/></svg> },
  { section: 'Settings' },
  { id: 'settings',     label: 'Company Settings',  icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="3"/><path d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-4 0v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83-2.83l.06-.06A1.65 1.65 0 004.68 15a1.65 1.65 0 00-1.51-1H3a2 2 0 010-4h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 012.83-2.83l.06.06A1.65 1.65 0 009 4.68a1.65 1.65 0 001-1.51V3a2 2 0 014 0v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 2.83l-.06.06A1.65 1.65 0 0019.4 9a1.65 1.65 0 001.51 1H21a2 2 0 010 4h-.09a1.65 1.65 0 00-1.51 1z"/></svg> },
  { id: 'roles',        label: 'Users & Roles',     icon: <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 00-4-4H5a4 4 0 00-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 00-3-3.87"/><path d="M16 3.13a4 4 0 010 7.75"/></svg> },
];

export default function Sidebar() {
  const { currentPage, goto, getCurrentUser, openModal, rentals, invoices, maintData, damages, refunds = [], dateChangeRequests = [], sidebarOpen, setSidebarOpen, isMobile, canView } = useApp();
  const user = getCurrentUser();
  const collapsed = !isMobile && !sidebarOpen;

  // ── Live badge counts ──────────────────────────────────────────────────────
  const overdueCount  = rentals.filter(r => r.status === 'overdue').length;
  const bookedCount   = rentals.filter(r => r.status === 'booked').length;
  const pendingBookings    = rentals.filter(r => r.source === 'online' && (r.confirmed === false || r.bankTransferPending)).length;
  const pendingDateChanges = (dateChangeRequests || []).filter(d => d.status === 'pending').length;
  const pendingRefunds     = refunds.filter(r => r.status === 'pending').length;
  // Incoming = bookings + date changes + refunds (everything the operator needs
  // to action today). Refunds also keeps its own badge for quick nav — both can
  // show the same number; Incoming is the "do-list" summary.
  const incomingCount      = pendingBookings + pendingDateChanges + pendingRefunds;
  const maintDueCount = (maintData || []).filter(m => {
    if (!m.nextDue) return false;
    const due = new Date(m.nextDue);
    const now = new Date();
    const inDays = (due - now) / 86400000;
    return inDays <= 14; // due within 2 weeks
  }).length;
  const unpaidInvoices = invoices.filter(i => i.status === 'pending' || i.status === 'overdue').length;
  const openDamages    = (damages || []).filter(d => {
    const openPayment = ['reported', 'charging', 'disputed', 'insurance'].includes(d.status);
    const notRepaired = !d.repaired && d.status !== 'resolved';
    return openPayment || notRepaired;
  }).length;

  const BADGES = {
    rentals:     overdueCount  > 0 ? { count: overdueCount,  cls: 'nb-r' }
               : bookedCount   > 0 ? { count: bookedCount,   cls: 'nb-b' } : null,
    incoming:    incomingCount > 0 ? { count: incomingCount, cls: 'nb-g' } : null,
    maintenance: maintDueCount > 0 ? { count: maintDueCount, cls: 'nb-a' } : null,
    damages:     openDamages   > 0 ? { count: openDamages,   cls: 'nb-a' } : null,
    invoices:    unpaidInvoices > 0 ? { count: unpaidInvoices, cls: 'nb-a' } : null,
    refunds:     pendingRefunds  > 0 ? { count: pendingRefunds,  cls: 'nb-a' } : null,
  };
  // ──────────────────────────────────────────────────────────────────────────

  return (
    <aside className={`sb${isMobile && sidebarOpen ? ' mobile-open' : ''}`} style={{
      width: isMobile ? 214 : (collapsed ? 56 : 214),
      transition: 'width .2s ease',
      flexShrink: 0,
    }}>
      {/* Logo */}
      <div className="sb-logo" style={{ padding: collapsed ? '16px 8px 12px' : '16px 16px 12px' }}>
        <div className="logo-row" style={{ justifyContent: collapsed ? 'center' : 'flex-start' }}>
          <div className="logo-ico">
            <svg viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2" strokeLinecap="round">
              <rect x="1" y="3" width="15" height="13" rx="2"/>
              <path d="M16 8h4l3 4v3h-7V8z"/>
              <circle cx="5.5" cy="18.5" r="2.5"/>
              <circle cx="18.5" cy="18.5" r="2.5"/>
            </svg>
          </div>
          {!collapsed && (
            <div>
              <div className="logo-name">FleetRent</div>
              <div className="logo-v">CRM v3.0</div>
            </div>
          )}
        </div>
      </div>

      {/* Navigation */}
      <nav className="sb-nav" style={{ padding: collapsed ? '8px 4px' : '8px 6px' }}>
        {NAV_STRUCTURE.map((item, i) => {
          if (item.section) {
            if (collapsed) return null;
            // Hide section header if no visible items under it
            const nextSectIdx = NAV_STRUCTURE.findIndex((n, j) => j > i && n.section);
            const end = nextSectIdx === -1 ? NAV_STRUCTURE.length : nextSectIdx;
            const hasVisible = NAV_STRUCTURE.slice(i + 1, end).some(si => canView(si.id));
            if (!hasVisible) return null;
            return <div key={i} className="nav-sec">{item.section}</div>;
          }
          // Hide nav items user can't view
          if (!canView(item.id)) return null;
          const badge = BADGES[item.id];
          return (
            <button
              key={item.id}
              className={`ni${currentPage === item.id ? ' active' : ''}`}
              onClick={() => goto(item.id)}
              title={collapsed ? item.label : ''}
              style={{
                justifyContent: collapsed ? 'center' : 'flex-start',
                padding: collapsed ? '7px 0' : '7px 10px',
              }}
            >
              <span style={{ width: 16, height: 16, flexShrink: 0, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {item.icon}
              </span>
              {!collapsed && item.label}
              {badge && !collapsed && <span className={`nb ${badge.cls}`}>{badge.count}</span>}
              {badge && collapsed && (
                <span style={{
                  position: 'absolute', top: 2, right: 2,
                  width: 8, height: 8, borderRadius: '50%',
                  background: badge.cls === 'nb-r' ? 'var(--ac)' : badge.cls === 'nb-g' ? 'var(--gr)' : 'var(--am)',
                }} />
              )}
            </button>
          );
        })}
      </nav>

      {/* Bottom: user + toggle */}
      <div className="sb-bot" style={{ padding: collapsed ? '8px 4px' : '8px 6px' }}>
        {/* Toggle button — hidden on mobile */}
        {!isMobile && <button
          onClick={() => setSidebarOpen(o => !o)}
          title={collapsed ? 'Expand sidebar' : 'Collapse sidebar'}
          style={{
            width: '100%', padding: '6px 10px', marginBottom: 6,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            gap: 6, border: 'none', background: 'transparent',
            cursor: 'pointer', borderRadius: 7, color: 'var(--tx3)',
            fontSize: 11, transition: 'all .12s',
          }}
          onMouseOver={e => e.currentTarget.style.background = 'var(--bg)'}
          onMouseOut={e => e.currentTarget.style.background = 'transparent'}
        >
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 14, height: 14, transform: collapsed ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }}>
            <path d="M11 17l-5-5 5-5M18 17l-5-5 5-5"/>
          </svg>
          {!collapsed && <span>Collapse</span>}
        </button>}

        {/* User chip */}
        <button
          className="user-chip"
          onClick={() => openModal('switch-user')}
          title={collapsed ? `${user?.fname || 'Vaggelis'} · Click to switch` : 'Click to switch user / view role'}
          style={{ justifyContent: collapsed ? 'center' : 'flex-start', padding: collapsed ? '7px 0' : '7px 10px' }}
        >
          <div className="uav" style={{ background: user?.color || 'var(--ac)' }}>
            {user?.initials || 'VG'}
          </div>
          {!collapsed && (
            <>
              <div style={{ flex: 1, textAlign: 'left' }}>
                <div style={{ fontSize: 12, fontWeight: 500 }}>{user?.fname || 'Vaggelis'}</div>
                <div style={{ fontSize: 10, color: 'var(--tx3)' }}>
                  {user?.roleId ? user.roleId.charAt(0).toUpperCase() + user.roleId.slice(1) : 'Admin'}
                </div>
              </div>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" style={{ width: 12, height: 12, color: 'var(--tx3)' }}>
                <path d="M17 8l4 4-4 4M7 8l-4 4 4 4"/>
              </svg>
            </>
          )}
        </button>
      </div>
    </aside>
  );
}
